














































































import { defineComponent, reactive, watch } from '@vue/composition-api';
import axios from 'axios';
import { OlbBreadcrumb, OlbBreadcrumbItem } from '../breadcrumb';
import OlbIcon from '../icon';
import OlbButton from '../button';
import OlbLoader from '../loader';

interface SearchResult {
	entries: Entry[];
	maxcount: number;
	term: string;
	title: string;
}

interface Entry {
	breadcrumbs: {
		title: string;
		url: string;
	}[][];
	description: string;
	highlight: boolean;
	title: string;
	url: string;
	size: string;
	filetype: string;
}

export default defineComponent({
	components: {
		OlbBreadcrumb,
		OlbBreadcrumbItem,
		OlbIcon,
		OlbButton,
		OlbLoader,
	},
	props: {
		action: {
			type: String,
			required: true,
		},
		loadmore: {
			type: String,
		},
		error: {
			type: String,
			required: false,
		},
		pagelength: {
			type: String,
			default: '10',
		},
		filtered: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const state = reactive<{
			page: number;
			searchResult: SearchResult | null;
			loading: boolean;
			error: boolean;
			searchParams: URLSearchParams;
		}>({
			page: 0,
			searchResult: null,
			loading: true,
			error: false,
			searchParams: new URLSearchParams(),
		});
		if (props.error) {
			return;
		}

		const filters = reactive<{ activeFilters: [][]; keys: string[] }>({
			activeFilters: [],
			keys: [],
		});

		const loadMore = (e?: Event) => {
			if (e) {
				e.preventDefault();
			}

			state.loading = true;
			axios({
				method: 'get',
				url: `${props.action}&page=${state.page}&pagelength=${props.pagelength}${
					state.searchParams.toString().length ? '&' : ''
				}${state.searchParams.toString()}`,
			})
				.then((res: { data: SearchResult }) => {
					state.loading = false;
					state.page++;
					if (!state.searchResult) {
						state.searchResult = res.data;
						return;
					}
					state.searchResult.entries.push(...res.data.entries);
				})
				.catch(() => {
					state.error = true;
				});
		};
		if (!props.filtered && !state.page) {
			loadMore();
		}
		watch(filters, () => {
			if (!filters.keys.length) {
				loadMore();
				return;
			}
			filters.activeFilters.forEach((filterItems, index) => {
				state.searchParams.delete(filters.keys[index]);
				filterItems.forEach((filterItem) => {
					state.searchParams.append(filters.keys[index], filterItem);
				});
			});
			state.searchResult = null;
			state.page = 0;
			loadMore();
		});

		return { state, loadMore, filters };
	},
});
